import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { geti18NValueConfig } from '@swf/components/StarsMPNotification/utils';
import type { MultiPurposeNotification } from '@swf/core/types/Notification';

import type { CardTranslationTag } from '../../config/NotificationTypes';

import styles from './CardDescription.scss';

export enum Variant {
  Default = 'default',
  Heading = 'heading'
}
interface Props {
  variant?: Variant;
  descriptionText?: string;
  attributes: MultiPurposeNotification['attributes'];
  descriptionKey?: CardTranslationTag;
}

const CardDescription: React.FC<Props> = ({
  attributes,
  descriptionText,
  descriptionKey,
  variant
}) => (
  <div className={classNames(styles.description, styles[variant as keyof typeof styles])}>
    {!descriptionText && descriptionKey?.tag && (
      <Translation
        {...descriptionKey.tag}
        values={geti18NValueConfig(descriptionKey.values, attributes)}
      />
    )}
    {descriptionText && <span>{descriptionText}</span>}
  </div>
);

export default CardDescription;
